import React from "react";
import Image from "next/legacy/image";

import { Button } from "components/atoms/button/button";
import {
  KelasLiveDownloadBlockContainer,
  KelasLiveDownloadBlockItemsWrapper,
  KelasLiveDownloadBlockTitle,
  KelasLiveDownloadBlockItem,
  KelasLiveDownloadBlockItemImageWrapper,
  KelasLiveDownloadBlockItemDesc,
  KelasLiveDownloadBlockVisitLink,
  KelasLiveDownloadBlockDownloadAppButton,
  KelasLiveDownloadBlockDownloadButtonWrapper,
  KelasLiveDownloadBlockAppsContainer,
  KelasLiveDownloadBlockAppImageWrapper,
  KelasLiveDownloadBlockTitleHighlight,
  KelasLiveDownloadBlockTitleStarLeftWrapper,
  KelasLiveDownloadBlockTitleStarRightLargeWrapper,
  KelasLiveDownloadBlockTitleStarRightSmallWrapper
} from "./kelas-live-download-block.styles";

import MobileMock from "public/assets/kelas-live/mobile-mock.png";
import LaptopMock from "public/assets/kelas-live/laptop-mock.png";
import GetOnAppStore from "public/assets/get_colearn_on_app_store.png";
import GetOnPlayStore from "public/assets/get_colearn_on_google_play.png";
import { Container } from "styles/common/container";
import { Star } from "components/icons/star";
import { Spacer } from "styles/common/spacer";
import Link from "next/link";

const KelasLiveDownloadBlock: React.FC = () => {
  return (
    <KelasLiveDownloadBlockContainer>
      <Container>
        <KelasLiveDownloadBlockTitle>
          <KelasLiveDownloadBlockTitleStarLeftWrapper>
            <Star />
          </KelasLiveDownloadBlockTitleStarLeftWrapper>
          Bisa ikut Kelas Live lewat{" "}
          <KelasLiveDownloadBlockTitleHighlight>
            aplikasi CoLearn
          </KelasLiveDownloadBlockTitleHighlight>{" "}
          atau{" "}
          <KelasLiveDownloadBlockTitleHighlight>
            website di laptop
          </KelasLiveDownloadBlockTitleHighlight>
          <KelasLiveDownloadBlockTitleStarRightLargeWrapper>
            <Star />
          </KelasLiveDownloadBlockTitleStarRightLargeWrapper>
          <KelasLiveDownloadBlockTitleStarRightSmallWrapper>
            <Star />
          </KelasLiveDownloadBlockTitleStarRightSmallWrapper>
        </KelasLiveDownloadBlockTitle>
        <Spacer token={[16, 16, 40]} />
        <KelasLiveDownloadBlockItemsWrapper>
          <KelasLiveDownloadBlockItem>
            <KelasLiveDownloadBlockItemImageWrapper>
              <Image
                src={MobileMock}
                alt="Live classes on mobile"
                layout="intrinsic"
                sizes="(min-width: 768px) 50vw, 100vw"
                width={340}
                height={170}
              />
            </KelasLiveDownloadBlockItemImageWrapper>
            <KelasLiveDownloadBlockItemDesc>
              Masuk ke Kelas Live di aplikasi CoLearn
            </KelasLiveDownloadBlockItemDesc>
            <Link href="https://colearn.app.link/DownloadCoLearn">
              <KelasLiveDownloadBlockDownloadAppButton>
                <Button variant="primary">Download aplikasi CoLearn</Button>
              </KelasLiveDownloadBlockDownloadAppButton>
            </Link>
            <KelasLiveDownloadBlockAppsContainer>
              <KelasLiveDownloadBlockAppImageWrapper href="https://colearn.app.link/DownloadCoLearn">
                <Image
                  src={GetOnAppStore}
                  alt="Download Colearn from Apple App Store"
                  objectFit="contain"
                  layout="fill"
                />
              </KelasLiveDownloadBlockAppImageWrapper>
              <KelasLiveDownloadBlockAppImageWrapper href="https://colearn.app.link/DownloadCoLearn">
                <Image
                  src={GetOnPlayStore}
                  alt="Download Colearn from Google Play Store"
                  objectFit="contain"
                  layout="fill"
                />
              </KelasLiveDownloadBlockAppImageWrapper>
            </KelasLiveDownloadBlockAppsContainer>
          </KelasLiveDownloadBlockItem>
          <KelasLiveDownloadBlockItem>
            <KelasLiveDownloadBlockItemImageWrapper>
              <Image
                src={LaptopMock}
                alt="Live classes on laptop"
                layout="intrinsic"
                sizes="(min-width: 768px) 50vw, 100vw"
                width={340}
                height={170}
              />
            </KelasLiveDownloadBlockItemImageWrapper>
            <KelasLiveDownloadBlockItemDesc>
              Masuk ke website Kelas Live di laptop
            </KelasLiveDownloadBlockItemDesc>
            <Link href="/login">
              <KelasLiveDownloadBlockDownloadButtonWrapper>
                <Button variant="primary">Masuk atau buat profil</Button>
              </KelasLiveDownloadBlockDownloadButtonWrapper>
            </Link>

            <KelasLiveDownloadBlockVisitLink>
              colearn.id/bimbel
            </KelasLiveDownloadBlockVisitLink>
          </KelasLiveDownloadBlockItem>
        </KelasLiveDownloadBlockItemsWrapper>
      </Container>
    </KelasLiveDownloadBlockContainer>
  );
};

export { KelasLiveDownloadBlock };
